module.exports = __webpack_public_path__ + "media/images/affiliates/feature-2-0d0f305d964855fc4d887732c5f7e363.jpg";